import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import { CircularProgress } from "@mui/material";
import { truncateRemark } from "../../helpers/helper";

const NotificationDetailsModal = ({ show, handleClose, columnData }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    handleClose();
  };

  console.log("::columnData::", columnData);

  useEffect(() => {
    fetchNotificationData();
  }, []);

  const fetchNotificationData = async () => {
    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        notificationId: columnData?.notificationId || "",
      };

      const response = await axiosPostApi(
        apiList.FETCH_NOTIFICATION_MASTER,
        payload
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);
        //   const modifiedData = modifyStructure(response?.data?.data);
        setData(response?.data?.data);
        if (response?.data?.data?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);
        setNoData(true);
        setData([]);
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const details = [];

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "900px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title font-medium">
                  Notification Details
                </h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {loading ? (
                    <CircularProgress className="circular-loader" />
                  ) : data && data?.length > 0 ? (
                    <div className="table-container" style={{ width: "100%" }}>
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Bag No</th>
                              <th style={{ textAlign: "center" }}>Bag ID</th>
                              <th>Created By</th>
                              <th>Created Date</th>
                              <th>Notification Id</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.map((item, index) => (
                              <tr key={index}>
                                <td>{item.bagNo || "-"}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.bagId || "-"}
                                </td>
                                <td>{item.createdBy || "-"}</td>
                                <td>{item.createdDate || "-"}</td>
                                <td>{item.notificationId || "-"}</td>
                                <td title={item.remarks || "-"}>
                                  {truncateRemark(item.remarks) || "-"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      No details available.
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-lg"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationDetailsModal;
